import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";
import "./Footer.css";
import BrandLogo from "./common/BrandLogo";

const Footer = () => {
  const socialLinks = [
    {
      label: "WhatsApp",
      href: "https://whatsapp.com/channel/0029Vb5fR5I6rsQmoskHy10s",
      icon: FaWhatsapp,
    },
    {
      label: "Facebook",
      href: "https://www.facebook.com/districtupdates",
      icon: FaFacebookF,
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/districtupdates/",
      icon: FaInstagram,
    },
    {
      label: "X",
      href: "https://x.com/district_india",
      icon: FaXTwitter,
    },
    {
      label: "YouTube",
      href: "https://www.youtube.com/@district.culture",
      icon: FaYoutube,
    },
  ];

  return (
    <footer className="district-footer">
      <div className="district-footer-inner">
        <div className="district-footer-top-row">
          <div className="district-footer-brand-column">
            <BrandLogo className="district-footer-logo" />
          </div>

          <nav className="district-footer-nav" aria-label="Footer links">
            <Link to="/about">Terms &amp; Conditions</Link>
            <Link to="/about">Privacy Policy</Link>
            <a href="mailto:abhiposhiya0104@gmail.com">Contact Us</a>
            <Link to="/movies">My Movies</Link>
          </nav>

          <div className="district-footer-qr-column">
            <img
              src="https://b.zmtcdn.com/data/edition_assets/17628835501492.svg"
              alt="Scan to download"
            />
            <p>Scan to download the app</p>
          </div>
        </div>

        <div className="district-footer-divider" />

        <div className="district-footer-bottom-row">
          <p>
            By accessing this page, you confirm that you have read, understood,
            and agreed to our Terms, Privacy Policy, and Content Guidelines. All
            rights reserved.
          </p>

          <div className="district-footer-social">
            {socialLinks.map((item) => {
              const Icon = item.icon;
              return (
                <a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={item.label}
                >
                  <Icon size={15} />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
